import {Mesh} from 'three'

export function cloneMesh (mesh){

    return new Mesh( mesh.geometry, mesh.material );

}